module.exports = __webpack_public_path__ + "static/HelveticaNeueLTW1G-Lt-b3a8954509771f826d2bbe0f0f049ab7.ttf";